<template>
    <div>
        <el-row>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item label="">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-form-item>
                <el-form-item label="请选择平台">
                    <el-select v-model="platformId" placeholder="请选择" clearable filterable @change="initSubTabMobule(platformId)">
                        <el-option
                                v-for="item in tabTreeData"
                                :key="item.platformId"
                                :label="item.platformName"
                                :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请选择动作">
                    <el-select v-model="actionId" clearable filterable placeholder="请选择动作" >
                        <el-option v-for="item in actionQueryData"
                                   :key="item.dictionaryKey"
                                   :label="item.dictionaryName"
                                   :value="item.dictionaryKey">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button-group style="margin-bottom:10px">
                        <el-button type="primary" size="mini" @click="getList">查询</el-button>
                        <el-button type="success" size="mini" @click="handleAdd">新增</el-button>
                        <el-tooltip class="item" effect="dark" content="点我下载导入模板" placement="top-end">
                            <el-button type="primary " size="mini" @click="downLoad()">下载导入模板</el-button>
                        </el-tooltip>
                    </el-button-group>

                </el-form-item>
            </el-form>
        </el-row>
        <el-container>
            <!--<vTree v-on:nodeClick="nodeClick"></vTree>-->
            <el-table :data="dataList" align="center" style="width:100%" v-loading="loading">
                <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="actionId" label="动作" width="120"></el-table-column>
                <el-table-column prop="actionName" label="动作名称" width="160"></el-table-column>
                <!--<el-table-column prop="delayTime" label="延时(秒)" width="70"></el-table-column>-->
                <el-table-column prop="messageType" width="90" label="消息类型" :formatter="messageTypeProcess"
                                 sortable></el-table-column>
                <el-table-column prop="messageName" label="消息名称" sortable></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180" sortable></el-table-column>
                <el-table-column label="操作" fixed="right" >
                    <template slot-scope="scope">
                        <el-button-group style="margin-bottom:10px">
                            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                            <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                            <el-tooltip class="item" effect="dark" content="可先发给自己看看消息" placement="top-end">
                                <el-button type="warning " size="mini" @click="handleTestMessage(scope.row)">测试</el-button>
                            </el-tooltip>
                            <el-button type="success " size="mini" @click="handleSendMessage(scope.row)">发送消息
                            </el-button>
                        </el-button-group>
                        <el-upload
                                multiple
                                :with-credentials="true"
                                :show-file-list="false"
                                class="upload-demo"
                                :action="importCustomerInfoUrlParam"
                                :on-success="uploadSuccess"
                                :data="{actionId:scope.row.actionId}">
                            <el-button size="small" type="success">上传用户<i class="el-icon-upload el-icon--right"></i>
                            </el-button>
                        </el-upload>
                    </template>
                </el-table-column>
            </el-table>
        </el-container>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="平台">
                    <el-select v-model="form.platformId" clearable filterable placeholder="平台"
                               :disabled="platformDisabled" @change="handlePlatformChange">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="动作Key" :required="true" v-show="false">
                    <el-select v-model="form.actionId" clearable filterable placeholder="动作Key"
                               @change="handleActionChange">
                        <el-option v-for="item in actionData"
                                   :key="item.dictionaryKey"
                                   :label="item.dictionaryName"
                                   :value="item.dictionaryKey">
                        </el-option>
                    </el-select>
                    <!--<a v-link="{path: '/dictionary'}">去添加动作</a>-->
                    <router-link to="/dictionary">去添加动作</router-link>
                </el-form-item>

                <el-form-item label="动作类型" v-show="false">
                    <el-select v-model="form.actionType" hidden clearable filterable placeholder="动作类型">
                        <el-option v-for="item in actionTypeData"
                                   :key="item.dictionaryKey"
                                   :label="item.dictionaryName"
                                   :value="item.dictionaryKey">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动" v-show="false">
                    <el-select v-model="form.activeNo" hidden clearable filterable placeholder="活动">
                        <el-option v-for="item in activeData"
                                   :key="item.activeNo"
                                   :label="item.activeName"
                                   :value="item.activeNo">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="延迟发送" v-show="false">
                    <el-input-number v-model="form.delayTime" hidden :min="0" :max="100000"
                                     label="请输入延迟发送秒数"></el-input-number>
                    (秒)

                </el-form-item>
                <el-form-item label="消息类型" :required="true">
                    <el-select v-model="form.messageType" clearable filterable placeholder="消息类型"
                               @change="messageTypeChange">
                        <el-option v-for="item in messageTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模板消息" :hidden=templateVisible :required="true">
                    <el-select v-model="form.messageId" clearable filterable placeholder="模板消息选择">
                        <el-option v-for="item in templateMessageData"
                                   :key="item.messageId"
                                   :label="item.messageName"
                                   :value="item.messageId">
                        </el-option>
                    </el-select>
                </el-form-item>
              <el-form-item label="MP订阅消息" :hidden=subcribeVisible :required="true">
                <el-select v-model="form.messageId" clearable filterable placeholder="模板消息选择">
                  <el-option v-for="item in mpSubcribeData"
                             :key="item.messageId"
                             :label="item.messageName"
                             :value="item.messageId">
                  </el-option>
                </el-select>
              </el-form-item>
                <el-form-item label="消息内容" :hidden=customizeVisible :required="true">
                    <el-select v-model="form.messageId" clearable filterable placeholder="选择消息内容">
                        <el-option v-for="item in customizeMessageData"
                                   :key="item.id"
                                   :label="item.keyword"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <router-link to="/wechatkeywordlist">去添加消息内容</router-link>
                </el-form-item>

                <el-form-item>
                    <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" size="mini" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="发送消息" :visible.sync="messageFormVisible" center>
            <el-form :model="messageform" label-width="80px">
                <el-form-item label="用户群">
                    <el-select v-model="messageform.customerType" clearable filterable placeholder="用户群"
                               @change="customerTypeChange">
                        <el-option v-for="item in cusertomerTypeData"
                                   :key="item.dictionaryKey"
                                   :label="item.dictionaryName"
                                   :value="item.dictionaryKey">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button-group>
                        <el-button @click="messageFormVisible = false">取 消</el-button>
                        <el-button type="primary" size="small"  @click="sendMessage()">确定发送</el-button>
                        <el-button type="success" size="small" @click="getCustomerNum()">查看导入用户数</el-button>
                        <el-button type="danger" size="small"  @click="deleteImport()">删除本次导入</el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
            <el-form :model="messageNumform" label-width="280px" v-show="messageNumFormVisible">
                <el-form-item label="导入人数">
                    <span>{{messageNumform.total}}</span>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 自定义用户群发送 -->
        <el-dialog title="自定义用户群发送消息" :visible.sync="customizedMessageFormVisible" center>
            <el-form :model="customizedMessageform">
                <el-form-item label="条件组合方式">
                    <el-select v-model="customizedMessageform.connector" placeholder="条件组合方式">
                        <el-option label="且" value="1"></el-option>
                        <el-option label="或" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="末单距今天数" :inline="true">
                    大于

                    <el-input-number v-model="customizedMessageform.lastCreateTimeBegin"></el-input-number>
                    天，小于等于

                    <el-input-number v-model="customizedMessageform.lastCreateTimeEnd"></el-input-number>
                    天

                </el-form-item>
                <el-form-item label="累计单数" :inline="true">
                    大于
                    <el-input-number v-model="customizedMessageform.totalOrderNumBegin"></el-input-number>
                    单，小于等于
                    <el-input-number v-model="customizedMessageform.totalOrderNumEnd"></el-input-number>
                    单
                </el-form-item>
                <el-form-item label="客单价" :inline="true">
                    大于
                    <el-input-number v-model="customizedMessageform.perOrderCostBegin"></el-input-number>
                    元，小于等于
                    <el-input-number v-model="customizedMessageform.perOrderCostEnd"></el-input-number>
                    元
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :disabled="customizedCheckButton" @click="checkCMessage()">查询用户数
                    </el-button>
                    <el-button type="primary" :disabled="customizedSendButton" @click="sendCMessage()">确定发送</el-button>
                    <el-button @click="customizedMessageFormVisible = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="消息推送测试" :visible.sync="showTest" center>
            <el-form >
                <el-form-item label="动作" :hidden="true">
                    <el-input v-model="actionId" placeholder="动作id"></el-input>
                </el-form-item>
                <el-form-item label="输入绑定的手机号或者openId查看消息">
                    <el-input v-model="user" placeholder="输入绑定的手机号或者openId查看消息"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="handleTest()">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        listMessageConfig,
        getPlatformList,
        saveMessageConfig,
        selectMessageConfig,
        deleteMessageConfig,
        getBuildPageTree,
        getKeywordsOption,
        getPlatformList2,
        getValidDictionaryList,
        getValiddictionarylist2,
        getTemplateMessagesOption,
        testSendMessage,
        previewMessageConfig,
        putAllUsersIntoRedisSet,
        pushAll,
        pushNoticeMQ,
        pushCustomizedNoticeMQ,
        getCustomerNum,
        deleteImportCustomer,
        importCustomerInfoUrl,
        downLoadMessageTemplate
    } from '../../api/api'
    import vTree from '@/components/platformTree.vue'
    import {getRouterPageHash} from '@/api/http';
    //定义组件
    export default{
        data(){
            return {
                dataList: [],
                messageTypeData: [{"id": 1, "name": "客服消息"}, {"id": 2, "name": "模板消息"}, {"id": 3, "name": "短信"}, {"id": 4, "name": "MP订阅消息"}],
                cusertomerTypeData: [],
                platformData: [],
                loading: false,
                platformId: 4,
                dialogFormVisible: false,
                messageFormVisible: false,
                customizedMessageFormVisible: false,
                messageNumFormVisible: false,
                messageSendType: 2,
                user:'',//测试用户手机号或者openId
                actionId:'',
                showTest:false,
                sendButton: false,//禁用发放按钮
                customizedCheckButton: false,//禁用自定义用户群查询按钮
                customizedSendButton: false,//禁用自定义用户群发送按钮
                form: {
                    "messageConfigId": "",
                    "actionId": "",
                    "delayTime": 0,
                    "filter": "",
                    "messageId": "",
                    "platformId": 4,
                    "createTime": "",
                    "actionType": "401",
                    "actionName": "",
                    "messageType": ""
                },
                messageform: {
                    "customerType": "",
                    "sendTime": ""
                },
                messageNumform: {
                    "total": 0,
                    "receivNum": 0
                },
                customizedMessageform: {
                    "connector": "1",
                    "lastCreateTimeBegin": "",
                    "lastCreateTimeEnd": "",
                    "totalOrderNumBegin": "",
                    "totalOrderNumEnd": "",
                    "perOrderCostBegin": "",
                    "perOrderCostEnd": ""
                },
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                formInline: {
                    "job_name": "",
                    "job_group": "",
                },
                platformDisabled: false,
                templateMessageData: [],
                customizeMessageData: [],
                mpSubcribeData:[],
                templateVisible: false,
                customizeVisible: true,
                subcribeVisible:true,
                actionTypeData: [],
                activeData: [],
                actionQueryData: [],
                actionId:'',
                actionData: [],
                subTabList: [],
                importCustomerInfoUrlParam: importCustomerInfoUrl,
            }
        },
        components: {
            'vTree': vTree,
            tabTreeData: function () {
                return this.$store.getters.getIndexModuleTabList
            },
        },
        //挂载时候执行
        mounted(){
            getPlatformList2().then((res) => {
                this.platformList = res.data;
                this.platformData = res.data;
                this.tabTreeData = res.data;
                this.getList(this.platformId);
                this.getActionList(this.platformList[0].platformGroupId);
            });
        },
        methods: {
            uploadSuccess(res){
                if (res.status == 500) {
                    this.$message({
                        showClose: true,
                        message: res.value,
                        type: 'error'
                    });
                }
                if (res.status == 400) {
                    this.$message({
                        showClose: true,
                        message: "请上传excel文件",
                        type: 'error'
                    });
                }
                if (res.status == 200) {
                    this.$message({
                        showClose: true,
                        message: res.value,
                        type: 'success'
                    });
                }
            },
            initSubTabMobule(id){
                //this.getList(id);
            },
            getActionList(platformGroupId){
                getValiddictionarylist2({platformGroupId:platformGroupId,dictionaryTypeId:52}).then((res) => {
                    if(res.data.success){
                        this.actionQueryData=res.data.value
                    }
                });
            },
            //定义查询方法
            getList(){
                this.loading = true;
                listMessageConfig({platformId: this.platformId,actionId:this.actionId}).then((res) => {
                    this.loading = false;
                    this.dataList = res.data.value;
                    //this.recordsTotal = res.data.total;
                })
            },
            downLoad(){
                let url = `${downLoadMessageTemplate}?pageRouterUrl=${getRouterPageHash(window.location.hash)}`
                window.open(url)
            },
            handleDel(row){
                if (confirm("确定删除选中的行吗？")) {
                    deleteMessageConfig({messageConfigId: row.messageConfigId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.platformId);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            handleActionChange(data){
                for (var key in this.actionData) {
                    if (this.actionData[key].dictionaryKey == data) {
                        this.form.actionName = this.actionData[key].dictionaryName;
                    }
                }
            },
            handlePlatformChange(data){
                //this.form.messageId = "";
                //关键字
                getKeywordsOption({platformId: data}).then((res) => {
                    console.log(res);
                    this.customizeMessageData = res.data;
                });
                //模板
                getTemplateMessagesOption({platformId: data}).then((res) => {
                    console.log(res);
                  this.templateMessageData  = res.data.filter((item, index,arr)=>{
                    return item.messageType==2
                  });
                  this.mpSubcribeData  = res.data.filter((item, index,arr)=>{
                    return item.messageType==4
                  });
                    //this.templateMessageData = res.data;
                    //this.mpSubcribeData=res.data;
                });
            },
            handleAdd(){
                this.form.platformId=this.platformId;
                this.platformDisabled = false;
                this.handleEdit({messageConfigId: 0});
            },
            handleAddSet(){
                putAllUsersIntoRedisSet({}).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSend(){
                pushAll({}).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSendMessage(data){
                this.form.actionId = data.actionId;
                this.messageFormVisible = true;
                this.getCustomerTypeList();
            },
            handleCustomizedSendMessage(data){
                this.form.actionId = data.actionId;
                this.customizedMessageFormVisible = true;
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                //得到实体
                selectMessageConfig({messageConfigId: data.messageConfigId}).then((res) => {
                    console.log("selectMessageConfig:");
                    console.log(res.data.messageConfig);
                    if (res.data.messageConfig != undefined) {
                        this.platformDisabled = true;
                        this.form = res.data.messageConfig;
                        this.messageTypeChange(res.data.messageConfig.messageType,1);
                        this.form.actionType = this.form.actionType + "";
                        //this.form.messageId=res.data.messageConfig.messageId;
                    } else {
                        this.form.messageConfigId = 0;
                    }
                    this.handlePlatformChange(this.platformId);
                    this.activeData = res.data.active;
                    this.actionTypeData = res.data.actionType;
                    this.actionData = res.data.action;
                });
            },
            nodeClick(data) {
                var ids = data;
                this.platformId = data;
                this.getList(data);
            },
            addAction(){
                this.$router.push({path:'/dictionary',name: 'dictionary'})
            },
            getCustomerTypeList(){
                getValidDictionaryList({
                    dictionaryTypeId: 57,
                    platformGroupId: 1000
                }).then((res) => {
                    if (res.data.status == 200) {
                        this.cusertomerTypeData = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            save(data){
                if (data.platformId == "") {
                    this.$message({
                        message: "请选择平台",
                        type: 'error'
                    });
                    return;
                }
//                if (data.actionId == "") {
//                    this.$message({
//                        message: "动作Key必填",
//                        type: 'error'
//                    });
//                    return;
//                }
//                if (data.actionName == "") {
//                    this.$message({
//                        message: "动作名称必填",
//                        type: 'error'
//                    });
//                    return;
//                }
                if (data.messageType == "") {
                    this.$message({
                        message: "消息类型必选",
                        type: 'error'
                    });
                    return;
                }
                if (data.messageId == "") {
                    this.$message({
                        message: "消息必选",
                        type: 'error'
                    });
                    return;
                }
                saveMessageConfig(data).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.getList(data.platformId);
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }

                });
            },
            messageTypeChange(data,type) {
                console.log(data);
                if(type==undefined){
                  this.form.messageId = "";
                }

                if (data == 1) {
                    this.templateVisible = true;
                    this.customizeVisible = false;
                    this.subcribeVisible = true;
                }
                if (data == 2) {
                    this.templateVisible = false;
                    this.customizeVisible = true;
                  this.subcribeVisible = true;
                }
                if (data == 3) {
                    this.templateVisible = true;
                    this.customizeVisible = false;
                  this.subcribeVisible = true;
                }
              if (data == 4) {
                this.subcribeVisible = false;
                this.customizeVisible = true;
                this.templateVisible = true;
              }
            },
            customerTypeChange(){
                //用户类型选择
            },
            handleTestMessage(data){
                this.showTest=true;
                this.actionId=data.actionId;
            },
            handleTest(data){
                if (this.user == null || this.user == '') {
                    this.$message({
                        message: "手机号/openId必选",
                        type: 'error'
                    });
                    return;
                } else {
                    previewMessageConfig({
                        openId: this.user,
                        actionId: this.actionId,
                    }).then((res) => {
                        this.showTest=false;
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.platformId);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            messageTypeProcess(row, column, cellValue) {
                for (var key in this.messageTypeData) {
                    if (this.messageTypeData[key].id == cellValue) {
                        return this.messageTypeData[key].name;
                    }
                }
            },
            getCustomerNum(){
                this.messageNumFormVisible = true;
                getCustomerNum({
                    customerType: this.messageform.customerType,
                    action: this.form.actionId
                }).then((res) => {
                    if (res.data.status == 200) {
                        this.messageNumform = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            reSendMessage(){
                //清除缓存
                this.messageSendType = 1;
                this.pushMessage();
            },
            sendMessage(){
                this.messageSendType = 2;
                this.sendButton = true;
                this.pushMessage();
            },
            checkCMessage(){
                this.customizedCheckButton = true;
                this.pushCustomizedMessage(0);
            },
            sendCMessage(){
                this.customizedSendButton = true;
                this.pushCustomizedMessage(1);
            },
            getNowFormatDate() {
                var now = new Date();
                var year = now.getFullYear();        //年
                var month = now.getMonth() + 1;   //月
                var day = now.getDate();            //日
                var hh = now.getHours();            //时
                var mm = now.getMinutes();         //分
                var ss = now.getSeconds();           //秒
                var clock = year + "-";
                if (month < 10)
                    clock += "0";
                clock += month + "-";
                if (day < 10)
                    clock += "0";
                clock += day + " ";
                if (hh < 10)
                    clock += "0";
                clock += hh + ":";
                if (mm < 10) clock += '0';
                clock += mm + ":";
                if (ss < 10) clock += '0';
                clock += ss;
                return (clock);
            },
            deleteImport(){
                this.$confirm('删除不可撤回, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteImportCustomer({action: this.form.actionId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                });
            },
            pushMessage(){
                this.$confirm('发送消息不可撤回, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    pushNoticeMQ({
                        customerType: this.messageform.customerType,
                        action: this.form.actionId,
                        platformId: this.platformId,
                        sendTime: this.getNowFormatDate(),
                        type: this.messageSendType
                    }).then((res) => {
                        this.sendButton = false;
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.platformId);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            },
            returnHistory(){
                window.history.back()
            },
            pushCustomizedMessage(type){
                this.customizedMessageform['type'] = type;
                this.customizedMessageform['action'] = this.form.actionId;
                this.customizedMessageform['platformId'] = 1;
                if (type == 1) {
                    this.$confirm('发送消息不可撤回, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        pushCustomizedNoticeMQ(this.customizedMessageform).then((res) => {
                            this.sendButton = false;
                            if (res.data.status == 200) {
                                this.$message({
                                    showClose: true,
                                    message: '成功',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.data.message,
                                    type: 'error'
                                });
                            }
                        });
                    });
                } else {
                    pushCustomizedNoticeMQ(this.customizedMessageform).then((res) => {
                        this.sendButton = false;
                        if (res.data.status == 200) {
                            this.$alert("一共" + res.data.value + "个用户");
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/wechat/messageConfig.vue